import { render, staticRenderFns } from "./EachCountryFurtherResource.vue?vue&type=template&id=424067f0&scoped=true&"
import script from "./EachCountryFurtherResource.vue?vue&type=script&lang=js&"
export * from "./EachCountryFurtherResource.vue?vue&type=script&lang=js&"
import style0 from "./EachCountryFurtherResource.vue?vue&type=style&index=0&id=424067f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424067f0",
  null
  
)

export default component.exports